export default __webpack_public_path__ + "static/media/PDF_file_icon.c7638de8.png";